<template>
  <div class="container-fluid">
    <div class="page-title">
      <div class="row">
        <div class="col-6">
          <h3>Dar de alta un cliente</h3>
        </div>
      </div>
    </div>

    <ClienteForm
      role="CLIENTE_REMITENTE"
      title="Registrar cliente remitente"
      subtitle="Completa el formulario para dar de alta un cliente remitente."
      submit-label="Dar de alta cliente"
      name-placeholder="Nombre del cliente"
      success-title="Cliente creado"
    />
  </div>
</template>

<script>
import ClienteForm from '@/components/clientes/ClienteForm.vue';

export default {
  name: 'AltaCliente',
  components: { ClienteForm },
};
</script>

